import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./css/aboutUs.css";

const AboutUs = () => {
    const gymEquipments = [
        {
            title: "أجهزة المشي",
            desc: "أجهزة الكارديو لتدريب التحمل وحرق السعرات الحرارية بشكل فعال.",
            img: "https://lh3.googleusercontent.com/aida-public/AB6AXuCO_Zg3yT4yrO5U4FYmMePoqfrissgqPGdNIL4sAY8Ru-xIjFDOSnO96n1b5-5KhAgqL2BiMtpaBuwLFo0vtbVttfvHawgRPRtJNrEm0SHqvcuR-mquGgL5FBruv9_--Txn2i--MzdAyHHFlZ-ZcND2cuqmnpj1gzD_lYDZf5ohquhcr-pQEFNchNMUt5uLBZRxwyXMZwGCymrzJkornx5j7UoepBVgErnx3kHMbid7t94YXqSq_bqlsrcR91OeGxg_7zXV11gOTEE",
        },
        {
            title: "الأجهزة الإهليلجية",
            desc: "كارديو منخفض التأثير لصحة المفاصل وتمارين الجسم بالكامل.",
            img: "https://lh3.googleusercontent.com/aida-public/AB6AXuBAJO_-IUEFSHlF4sFzAeVQUuJc6KsLg0aJBl5nmegvx4nH4_h480V4I7kkaemmqCKjG2rto0jsvpKKXqTJAOb0GpNoBUz1pu7NsocKd7HiHbLzaRE9RhE93FBNxQeidQfZkjaQaGufQ4FaGeg7lgfkopAhlr_rrCTw1LDm_2bOQgMfcci94vsA7I9A5jTFNsziO7wckNnw_1hTJtY98sni-GXx-q66CNVCoDphiw3HzkLTQDZ5d8DYJN1dJM0qRYKWYxtqF-mOXfI",
        },
        {
            title: "الدراجات الثابتة",
            desc: "ركوب الدراجات في الأماكن المغلقة للتمارين عالية الكثافة وقوة الساق.",
            img: "https://lh3.googleusercontent.com/aida-public/AB6AXuBBQfhtRfo53KPAisUc2-wR55cnTgGfwSxqML_1BVOs0Qbei6CKQPtkXMLJO_gcile3_w98r2tFud4Osf7xtFwnudTZopxLiLjEafB01chnjmoTtVAtvCXhijRzfpaiMb9WZ6jVhvO6wD2KR56jrko8sAadmiWMoBaHRAoDS9wlrrPOWzFgZqqsikr3jTxD37fL2WEimUIU5GQ_Sv1MSpoHfWUNQ5C7zoeyphnWA5S_oiXl3ZoAbu5w97Xr65VBR5qNxGiMrI8I-8E",
        },
        {
            title: "أجهزة الأوزان",
            desc: "آلات لتطوير العضلات المستهدفة ورفع الأثقال بأمان.",
            img: "https://lh3.googleusercontent.com/aida-public/AB6AXuDy4TG1Zv807K24wsxnKWPDBpuIzfz4den3Rx1BaIOqcPaCHAT8dBMDQqEr-e5RlnHW--lh1AzaCSHyit2SO4pg8zS1VN5-hqod6VYRK4pnbrW4SX1VJtctAdpQO8QxwDBgI_PhcETjF-ivaiAJjTPOcb8M6Ru8kO-8xAC_R9SqPNQgJ9CB1Easeg4s81Nq_MRdsbeJ7OEH4Qa5H3DaSxFps762kpIZK6I2DG8dX82sZR57dVGkCCHW2K_68YvhIrenqo2bufIC1-s",
        },
        {
            title: "الأوزان الحرة",
            desc: "الدمبل والأثقال لبناء القوة واللياقة الوظيفية.",
            img: "https://lh3.googleusercontent.com/aida-public/AB6AXuBBax_VVACRymCMtQtJePfMJ-H70Nh0MKGK643siS_aJQ6np0ILPKQhv9vHWCWCdKiwuK2lXUN_w4fIol4IDm_juVpfDAzr7gJJbUXbFqOn7JVgcUH3JHhzt-BjKIbjLPZxNPeg_Pw9lFTmcJQPjGg7H6pvuGvsCInbCEKseyvBbvtX9Fpn0bVhp5Dh_t5f4d3Lna9fur-LUfn5nR5Bf2b91mh4s7F3GO2ttGfBHdnjW5u-abAiwgkah_PNERsH5vG7IcPOER__6ak",
        },
        {
            title: "منطقة التدريب الوظيفي",
            desc: "مساحة متعددة الاستخدامات للتمارين الديناميكية واستقرار الجذع.",
            img: "https://lh3.googleusercontent.com/aida-public/AB6AXuChLF9uBQ2M1NkbJDaEASV3EihX7kJegam4HqLu8IfSCt5tIcRelIKPaLiymSVRtVqh81cuAbdvbadiDJ6Oz_jPlzuOMFY1F38L6bAdmukwPJPO1uL9RokXOI95Rg7rKJC2NTl3j7gTepe4uKI4NC0dPfauWiLCZ8lnT_KLjLO1A0o4Uzo9-E8h_Pml_zhp9Km5102lFdJ_F4ol_wgTJr0SZZE3BxDIJIn5Kbkqz591_MOld5e2kkINXztxYKPrNikOh9pWMCrGPnE",
        },
    ];

    const [activeIdx, setActiveIdx] = useState(null);

    const toggleOverlay = (idx) => {
        setActiveIdx(activeIdx === idx ? null : idx);
    };

    return (
        <div className="about-page bg-light text-dark">
            <section className="hero-section text-center d-flex flex-column justify-content-center align-items-center">
                <div className="hero-overlay"></div>
                <div className="hero-content px-3 text-center">
                    <h1 className="display-4 fw-bold">The Force Gym</h1>
                    <p className="lead">انطلق نحو لياقتك القصوى بقوة واحتراف.</p>
                    <p>في The Force Gym، نقدم بيئة محفزة ومجهزة بأحدث المعدات لمساعدتك على تحقيق أهدافك الصحية واللياقية.</p>
                </div>
            </section>

            <section className="py-5">
                <div className="container">
                    <h2 className="text-center mb-4">أجهزتنا</h2>
                    <p className="text-center mb-5 text-muted">أفضل الأجهزة لكل احتياجات التمرين.</p>
                    <div className="row g-4">
                        {gymEquipments.map((item, idx) => (
                            <div key={idx} className="col-12 col-md-6 col-lg-4">
                                <div
                                    className="card text-white border-0 overflow-hidden shadow-lg equipment-card"
                                    onClick={() => toggleOverlay(idx)}
                                >
                                    <div
                                        className="card-img"
                                        style={{ backgroundImage: `url(${item.img})` }}
                                    ></div>
                                    <div className={`overlay ${activeIdx === idx ? "active" : ""}`}>
                                        <div className="card-body">
                                            <h5 className="card-title">{item.title}</h5>
                                            <p className="card-text">{item.desc}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AboutUs;
